<template>
  <div :class="['d-lg-none mt-3', noBottom ? '' : 'mb-4']">
    <app-button type="submit" :loading="loading">
      <slot />
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton'

export default {
  name: 'MobileSubmitButton',
  components: { AppButton },
  props: {
    loading: { type: Boolean, default: false },
    noBottom: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MobileSubmitButton.vue